<template>
    <div>
        <v-menu v-model="isShowIssueBulkInvoicesSupplierMenu" :close-on-content-click="false">
            <template v-slot:activator="{props}">
                <v-btn
                    :loading="isLoadingIssueBulkInvoicesSupplier"
                    variant="text"
                    :color="'primary'"
                    size="x-small"
                    v-bind="props"
                    @click="isShowIssueBulkInvoicesSupplierMenu = true"
                >
                    {{ label }}
                </v-btn>
            </template>
            <v-card>
                <v-card-title v-if="label">{{ label }}</v-card-title>
                <v-card-text>
                    <v-radio-group
                        v-model="radioGroupIssueBulkInvoicesSupplier"
                        density="compact"
                        hide-details
                        class="mt-0"
                    >
                        <v-radio
                            v-for="radioItem in receiveInvoicesRadioItems"
                            :key="radioItem.value"
                            :label="radioItem.label"
                            :disabled="radioItem.disabled"
                            :value="radioItem.value"
                        />
                    </v-radio-group>
                </v-card-text>
                <v-card-actions class="px-4">
                    <v-btn
                        class="full-width"
                        :color="'primary'"
                        variant="flat"
                        :loading="isLoadingIssueBulkInvoicesSupplier"
                        :disabled="radioGroupIssueBulkInvoicesSupplier === '' || isLoadingIssueBulkInvoicesSupplier"
                        @click="issueBulkInvoicesSupplier"
                    >
                        {{ $t('confirm') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-menu>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class IssueBulkManualInvoicesMenu extends Vue {
        @Prop({required: true}) invoiceType
        @Prop({required: true}) filterKey
        @Prop() label
        @Prop() selectedObjectIds

        isShowIssueBulkInvoicesSupplierMenu = false
        isLoadingIssueBulkInvoicesSupplier = false
        radioGroupIssueBulkInvoicesSupplier = ''

        async issueBulkInvoicesSupplier() {
            this.isLoadingIssueBulkInvoicesSupplier = true

            try {
                if (this.radioGroupIssueBulkInvoicesSupplier === 'selected') {
                    await this.$api.issueBulkManualInvoices.post({
                        orderIds: this.selectedObjectIds,
                        filterKey: this.filterKey,
                        invoiceType: this.invoiceType,
                    })
                } else {
                    await this.$api.issueBulkManualInvoices.post({
                        filterKey: this.filterKey,
                        invoiceType: this.invoiceType,
                    })
                }

                this.isShowIssueBulkInvoicesSupplierMenu = false
                this.$toast.success(this.$t('success_message.saved_successfully'))
            } catch (e) {
                this.$toast.error(this.$t('error_message.something_went_wrong'))
            } finally {
                this.isLoadingIssueBulkInvoicesSupplier = false
            }
        }

        get receiveInvoicesRadioItems() {
            return [
                {
                    value: 'selected',
                    label: `${this.$t('selected_orders')} ${this.selectedObjectIds?.length || 0}`,
                    disabled: !this.selectedObjectIds?.length,
                },
                {value: 'all', label: this.$t('all_orders')},
            ]
        }

        get isDisabled() {
            return this.radioGroupIssueBulkInvoicesSupplier === '' || this.isLoadingIssueBulkInvoicesSupplier
        }
    }

    export default IssueBulkManualInvoicesMenu
</script>
